import { Link } from "react-router-dom";

const TIKTOK_HANDLE = "thatsgirlcodepod";

const VIDEO_IDS = [
  "7622772038578556174",
  "7607300866420247822",
  "7559666693325196574",
];

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://instagram.com/thatsgirlcodepod",
    Icon: InstagramIcon,
  },
  {
    name: "TikTok",
    href: `https://www.tiktok.com/@${TIKTOK_HANDLE}`,
    Icon: TikTokIcon,
  },
  {
    name: "X",
    href: "https://x.com/thatsgirlcodepd",
    Icon: XIcon,
  },
];

export default function SocialsSection() {
  return (
    <section
      className="bg-cream flex flex-col items-center px-6 sm:px-10 py-14 sm:py-20"
      style={{ position: "relative", zIndex: 20 }}
    >
      <p
        className="font-montserrat"
        style={{
          fontSize: "14px",
          fontWeight: 600,
          letterSpacing: "0.26em",
          color: "rgba(87,19,16,0.92)",
          textTransform: "uppercase",
          marginBottom: "18px",
        }}
      >
        Follow us on our socials
      </p>

      <div className="flex items-center justify-center gap-6 sm:gap-8">
        {SOCIALS.map(({ name, href, Icon }) => (
          <a
            key={name}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={name}
            className="inline-flex items-center justify-center rounded-full transition-transform transition-colors duration-200 hover:-translate-y-0.5 hover:bg-darkred focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-darkred"
            style={{
              width: "72px",
              height: "72px",
              backgroundColor: "#571310",
              color: "#fffcef",
            }}
          >
            <Icon />
          </a>
        ))}
      </div>

      <p
        className="font-montserrat"
        style={{
          fontSize: "20px",
          color: "rgba(26,10,10,0.85)",
          marginTop: "22px",
          marginBottom: "50px",
          textAlign: "center",
          maxWidth: "640px",
          lineHeight: 1.55,
        }}
      >
        Quick takes, behind-the-scenes, and the moments that didn’t make the cut.
      </p>

      <div className="flex flex-col lg:flex-row items-center justify-center gap-8 w-full">
        {VIDEO_IDS.map((id, i) => (
          <div
            key={id}
            className="group overflow-hidden rounded-2xl bg-black animate-scale-in transition-transform duration-300 ease-out hover:-translate-y-1.5"
            style={{
              width: "340px",
              maxWidth: "100%",
              boxShadow:
                "0 10px 30px -12px rgba(87,19,16,0.35), 0 4px 12px -4px rgba(87,19,16,0.18)",
              animationDelay: `${i * 120}ms`,
            }}
          >
            <iframe
              title={`TikTok video ${id}`}
              src={`https://www.tiktok.com/embed/v2/${id}`}
              width="340"
              height="700"
              frameBorder={0}
              scrolling="no"
              allow="autoplay; fullscreen; encrypted-media; picture-in-picture;"
              allowFullScreen
              style={{ display: "block", maxWidth: "100%" }}
            />
          </div>
        ))}
      </div>

      <Link
        to="/contact"
        state={{ label: "Brand & sponsorship" }}
        className="font-montserrat inline-flex items-center justify-center transition-transform transition-colors duration-200 hover:-translate-y-0.5 hover:bg-darkred focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-darkred active:translate-y-0"
        style={{
          marginTop: "44px",
          padding: "16px 32px",
          backgroundColor: "#571310",
          color: "#fffcef",
          borderRadius: "999px",
          fontSize: "16px",
          fontWeight: 600,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          textDecoration: "none",
        }}
      >
        Partner with us →
      </Link>
    </section>
  );
}

function InstagramIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="32"
      height="32"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="32"
      height="32"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.62 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.66-.1z" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="30"
      height="30"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
